module.exports = __webpack_public_path__ + "static/media/pencil-edit-button.becc186b.svg";